<div class="content">
  <ng-container>
    <img [src]="src" alt="" />
    <span class="title">{{ title }}</span>
    <a [href]="url" target="_blank">
      <button *ngIf="!text" mat-stroked-button color="primary">点击关注</button>
    </a>
    <span class="text" *ngIf="text">{{ text }}</span>
  </ng-container>
</div>
